import $ from 'jquery';
import screencheck from "./screencheck";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { power1, power2, power3, power4 } from "gsap";
import { delay, eq } from 'lodash';
gsap.registerPlugin(CustomEase);

CustomEase.create("hop", "M0,0,C0.56,0.032,0.248,1,1,1");

var animationDuration = 0.5,
    animationEase = 'hop';

/* Menu Icon Append prepend for responsive
---------------------------------------------------------------------*/
$(window).on('resize', function() {
    if (screencheck(991)) {
        if (!$('.backtomenu').length) {
            $('.nav-main').prepend('<div class="backtomenu-row"><a href="#" class="backtomenu">zurück</a></div>');
        }
    } else {
        $(".backtomenu").remove();
    }
}).resize();


/* Menu Icon Append prepend for responsive
---------------------------------------------------------------------*/
$(window).on('resize', function() {
    if (screencheck(991)) {
        if (!$('#menu').length) {
            $('#mainmenu').prepend('<a href="#" id="menu" class="menulines-button"><span class="menulines"></span></a>');
        }
    } else {
        $("#menu").remove();
    }
}).resize();



/* Mobile menu click
---------------------------------------------------------------------*/
var $body = $('body');

$(document).on('click', "#menu", function() {
    
    // $body.addClass('overflowhidden');
    $body.addClass('submenu-active');
    // For menu open

    
    if ($(this).next('.menu-main').is(':visible')) {

        if ($('.menu-main > ul > li').hasClass('open')) {
            // If submenu open
            gsap.fromTo($('.menu-main > ul > li.open > .nav-main'), { transform: 'translateX(0%)' }, { transform: 'translateX(100%)', duration: 0.350, ease: animationEase });
            $('.menu-main > ul > li.open').removeClass('open');
            setTimeout(() => {
                $(this).removeClass('menuopen');
                // $(this).next('.menu-main').slideUp('normal');
                $(this).next('.menu-main').fadeOut('normal');
                //$body.removeClass('overflowhidden');
                $body.removeClass('submenu-active');
            }, 350);

        } else {
            // If submenu not open
            $(this).removeClass('menuopen');
            
            // $(this).next('.menu-main').slideUp('normal');
            $(this).next('.menu-main').fadeOut('normal');
            //$body.removeClass('overflowhidden');
            $body.removeClass('submenu-active');
            gsap.fromTo($(".menu-main > ul > li, .menu-main > .header-contact"), { opacity: 1, y: '0' }, { opacity: 0, y: '-30px', stagger: -0.025, duration: animationDuration, ease: animationEase ,clearProps: "all" });
        }
        if(screencheck(991)){ 
            $('.has-menu').removeClass('open')
            gsap.set('.sub-menu-container',{
                x: '100%',
                opacity: 0
            })
            $('#mainmenu .nav-main, .sub-menu-container').each(function(index ,elem) {
                if($(elem).attr('style')){
                    let attr = $(elem).attr('style')
                    if(attr.includes('overflow: hidden')){
                        $(elem).css('overflow' , '')
                    }
                }
            })
        }
    }
    // For menu close
    else {
        //$body.addClass('overflowhidden');
        $body.addClass('submenu-active');
        $(this).addClass('menuopen');
        // $(this).next('.menu-main').slideDown('normal');
        $(this).next('.menu-main').fadeIn({
            start: function() {
                $(this).css({
                    display: "flex"
                })
            }
        });
        // $(this).next('.menu-main').slideDown({
        //     start: function () {
        //         $(this).css({
        //           display: "flex"
        //         })
        //       }
        // });
        gsap.fromTo($(".menu-main > ul > li, .menu-main > .header-contact"), { opacity: 0, y: '-30px'}, { opacity: 1, y: '0', stagger: 0.025, duration: animationDuration, ease: animationEase, clearProps: "all" });
    }
    return false;
});


// Click outside close menu
$(document).on('click', function(e) {

    if (!(($(e.target).closest(".nav-row").length > 0) || ($(e.target).closest(".nav-row").length > 0))) {
        if (!screencheck(991)) {

            if ($('.nav-main').is(':visible')) {

                gsap.fromTo($(".nav-box ul:not(:hidden) > li > a, .nav-box h6"), { opacity: 1, y: '0' }, {
                    opacity: 0,
                    y: '-30px',
                    stagger: -0.025,
                    duration: animationDuration,
                    ease: animationEase,
                    onComplete() {
                        $('.nav-main').hide();
                        $('.nav-overlay').fadeOut(500);
                        $('.nav-box > ul').find('.has-menu.open').removeClass('open')
                        $('.nav-box > ul > li.has-menu').find('ul.open').removeClass('open').addClass('not-opened').css('display' , 'none')
                        // gsap.to($('.nav-overlay'), {opacity: '0', duration:animationDuration, ease:animationEase, onComplete(){
                        //     this._targets[0].style.display = 'none';
                        //     // $navItem.find('.nav-main').style.display = 'none';
                        // }});
                        // $('.menu-main > ul').css('pointer-events','auto');
                    }
                });
                
                $('#mainmenu .menu-main > ul > li').removeClass('open');

                
                //$('body').removeClass('overflowhidden');
                $body.removeClass('submenu-active');
            }
        }

    }
})

/* Back to menu click
---------------------------------------------------------------------*/
$(document).on('click', ".backtomenu", function() {
    $(this).parents('li').removeClass('open');
    gsap.fromTo($(this).parents('li').find('.nav-main'), { transform: 'translateX(0%)' }, { transform: 'translateX(100%)', duration: animationDuration, ease: animationEase });
    setTimeout(() => {
        $(this).parents('li').find('.nav-main').hide();
    }, 1000);
    return false
});



function navItem(element) {
    $(element).on('click', function() {
   
        var subMenu = $(element).next('.nav-main'),
            subMenuParent = $(element).parent('li'),
            subMenuParentOpen = $(element).parent('li.open'),
            openSubMenu = subMenuParentOpen.children('.nav-main'),
            $body = $('body');
        var $this = $(this),
            $navItem = $this.parent('li'),
            $navItemOpen = $this.parent('li').hasClass('open');
           
        // if (!screencheck(991)) {
        if ($navItemOpen) {
            // console.log('close');
            // gsap.to($('.nav-overlay'), {opacity: '0', duration:animationDuration, ease:animationEase, onComplete(){
            //     this._targets[0].style.display = 'none';
            // }});
            $navItem.removeClass('open');
           
            //$body.removeClass('overflowhidden');
            $body.removeClass('submenu-active');
            // $('.menu-main > ul').css('pointer-events','none');
            if (!screencheck(991)) {
                let elem = []
                // alert('close');
                // gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateY(0%)'}, {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase});
                // gsap.fromTo(".nav-box li, .nav-box h6", {opacity: 1, y: '0'}, {opacity: 0, y: '-30px', stagger: -0.015, duration:animationDuration, ease: animationEase});
                // gsap.to($navItem.find('.nav-main'), {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase, onComplete(){
                //     // console.log(this._targets[0]);
                //     this._targets[0].style.display = 'none';
                // }});

                $navItem.find(".nav-box  ul:not(:hidden) ,.nav-box h6 ").each(function() {
                    if($(this).is('h6')){
                        elem.push($(this)[0])
                    }else{
                        elem.push(...[...$(this).children('li').children('a')])
                    }
                })
                
                gsap.fromTo(elem, { opacity: 1, y: '0' }, {
                    opacity: 0,
                    y: '-30px',
                    stagger: -0.025,
                    duration: animationDuration,
                    ease: animationEase,
                    onComplete() {
                        $navItem.find('.nav-main').hide();
                        $('.nav-overlay').fadeOut(500);
                        $('.nav-box > ul').find('.has-menu.open').removeClass('open')
                        $('.nav-box > ul > li.has-menu').find('ul.open').removeClass('open').addClass('not-opened').css('display' , 'none')

                        // gsap.to($('.nav-overlay'), {opacity: '0', duration:animationDuration, ease:animationEase, onComplete(){
                        //     this._targets[0].style.display = 'none';
                        //     // $navItem.find('.nav-main').style.display = 'none';
                        // }});
                        // $('.menu-main > ul').css('pointer-events','auto');
                    }
                });


                // gsap.fromTo(".nav-box li, .nav-box h6", {opacity: 1, y: '0'}, {opacity: 0, y: '-30px', stagger: -0.015, duration:animationDuration, ease: animationEase, onComplete(){
                //     $navItem.find('.nav-main').style.display = 'none';
                // }});
                // setTimeout(() => {
                //     $navItem.find('.nav-main').hide();
                // }, 1000);
            } else {
                // gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateX(0%)'}, {transform: 'translateX(100%)', duration:animationDuration, ease:animationEase});
                gsap.to($navItem.find('.nav-main'), {
                    transform: 'translateX(100%)',
                    duration: animationDuration,
                    ease: animationEase,
                    onComplete() {
                        this._targets[0].style.display = 'none';
                    }
                });
                // setTimeout(() => {
                //     $navItem.find('.nav-main').hide();
                // }, 1000);
            }
        } else {
            if (subMenuParent.hasClass('open')) {
                if (!screencheck(991)) {
                    
                    // console.log('open menu');
                    // $('.menu-main > ul').css('pointer-events','none');
                    // gsap.fromTo(openSubMenu, {transform: 'translateY(0%)'}, {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase});
                    // gsap.to(openSubMenu, {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase, onComplete(){
                    //     // console.log(this._targets[0]);
                    //     this._targets[0].style.display = 'none';
                    //     // console.log($navItem);

                    //     // After close all menu open current menu
                    //     // var curr = $navItem[0];
                    //     // var currNav = $navItem.find('.nav-main')[0];
                    //     // console.log(currNav);
                    //     // curr.classList.add('open');
                    //     // gsap.to(currNav, {transform: 'translateY(0%)', duration:animationDuration, ease:animationEase});
                    // }});
                    let isDone = true;
                    gsap.fromTo(openSubMenu.find(".nav-box ul:not(:hidden) > li > a, .nav-box h6"), { opacity: 1, y: '0' }, {
                        opacity: 0,
                        y: '-30px',
                        stagger: -0.025,
                        duration: animationDuration,
                        ease: animationEase,
                        onComplete() {
                            openSubMenu.hide();
                        },
                        onUpdate: function() {
                            if(this.totalTime() >= animationDuration + 0.2){
                                if(isDone){
                                    closeLiItems();
                                    isDone = false
                                }
                            }
                        },
                        onStart(){
                            isDone = true
                        }
                    });
                    // gsap.to(openSubMenu, {transform: 'translateY(-100%)', duration:animationDuration, ease:animationEase, onComplete(){
                    //     // console.log(this._targets[0]);
                    //     this._targets[0].style.display = 'none';
                    //     // console.log($navItem);

                    //     // After close all menu open current menu
                    //     // var curr = $navItem[0];
                    //     // var currNav = $navItem.find('.nav-main')[0];
                    //     // console.log(currNav);
                    //     // curr.classList.add('open');
                    //     // gsap.to(currNav, {transform: 'translateY(0%)', duration:animationDuration, ease:animationEase});
                    // }});
                    // setTimeout(() => {
                    //     openSubMenu.hide();
                    // }, 1000);
                } else {
                    // gsap.fromTo(openSubMenu, {transform: 'translateX(0%)'}, {transform: 'translateX(100%)', duration:animationDuration, ease:animationEase});
                    gsap.to(openSubMenu, {
                        transform: 'translateX(100%)',
                        duration: animationDuration,
                        ease: animationEase,
                        onComplete() {
                            this._targets[0].style.display = 'none';
                        }
                    });
                    // setTimeout(() => {
                    //     openSubMenu.hide();
                    // }, 1000);
                }
                subMenuParent.removeClass('open');
                function closeLiItems() {
                    // setTimeout(() => {
                        $navItem.addClass('open');
                        if (!screencheck(991)) {
                            $navItem.find('.nav-main').show(0, function() {
                                // gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateY(-100%)'}, {transform: 'translateY(0%)', duration:animationDuration, ease:animationEase});
                                // gsap.to($navItem.find('.nav-main'), {transform: 'translateY(0%)', duration:animationDuration, ease:animationEase});
                                gsap.fromTo($navItem.find(".nav-main .nav-box ul:not(:hidden) > li > a, .nav-main .nav-box h6"), { opacity: 0, y: '-30px' }, {
                                    opacity: 1,
                                    y: '0',
                                    stagger: 0.025,
                                    duration: animationDuration,
                                    ease: animationEase,
                                    onComplete() {
                                        // $('.menu-main > ul').css('pointer-events','auto');
                                    }
                                });
                                // gsap.fromTo(".nav-box li, .nav-box h6", {opacity: 0, y: '-30px'}, {opacity: 1, y: '0', stagger: 0.015, duration:animationDuration, ease: animationEase, delay:0.15});
                            })
                        } else {
                            $navItem.find('.nav-main').show(0, function() {
                                // gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateX(100%)'}, {transform: 'translateX(0%)', duration:animationDuration, ease:animationEase});
                                gsap.to($navItem.find('.nav-main'), { transform: 'translateX(0%)', duration: animationDuration, ease: animationEase });
                            })
                        }
                    // }, 0);
                }
            } else {

                // console.log('open');
                $navItem.addClass('open');
                //$body.addClass('overflowhidden');
                $body.addClass('submenu-active');
                // $('.menu-main > ul').css('pointer-events','none');
                if (!screencheck(991)) {
                    // alert('open');
                    let openingElem = []
                    $('.nav-overlay').fadeIn(500);
                    // $('.nav-overlay').show(0, function () {
                    //     gsap.to($('.nav-overlay'), {opacity: '1', duration:animationDuration, ease:animationEase});
                    // });

                    $navItem.find('.nav-main').show(0, function() {
                        $navItem.find(".nav-box  ul:not(:hidden) ,.nav-box h6 ").each(function() {
                            if($(this).is('h6')){
                                openingElem.push($(this)[0])
                            }else{
                                openingElem.push(...[...$(this).children('li').children('a')])
                            }
                        })
                        // gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateY(-100%)'}, {transform: 'translateY(0%)', duration:animationDuration, ease:animationEase});
                        // gsap.to($navItem.find('.nav-main'), {transform: 'translateY(0%)', duration:animationDuration, ease:animationEase, onComplete() {
                        //     // console.log(this._targets[0]);
                        // }});

                        // gsap.fromTo(".nav-box li, .nav-box h6", {opacity: 0, y: '-30px'}, {opacity: 1, y: '0', stagger: 0.10, duration:animationDuration, ease: animationEase, delay:0.15});
                        // gsap.fromTo($navItem.find(".nav-box li"), $navItem.find(".nav-box h6"), {opacity: 0, y: '-30px'}, {opacity: 1, y: '0', stagger: 0.10, duration:animationDuration, ease: animationEase, delay:0.15});
                        gsap.fromTo(openingElem, { opacity: 0, y: '-30px' }, {
                            opacity: 1,
                            y: '0',
                            stagger: 0.025,
                            duration: animationDuration,
                            ease: animationEase,
                            clearProps : true,
                            onComplete() {
                                // $('.menu-main > ul').css('pointer-events','auto');
                            }
                        });
                    })
                } else {
                    $navItem.find('.nav-main').show(0, function() {
                        // gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateX(100%)'}, {transform: 'translateX(0%)', duration:animationDuration, ease:animationEase});
                        gsap.to($navItem.find('.nav-main'), { transform: 'translateX(0%)', duration: animationDuration, ease: animationEase });
                    })
                }
            }
            // if( $navItem.is($navItem) && !$navItemOpen ){
            //     $navItem.addClass('open');
            //     gsap.fromTo($navItem.find('.nav-main'), {transform: 'translateY(0%)'}, {transform: 'translateY(-100%)', duration:0.350});
            // }

        }
       
        // }
        // This js for mobile
        // else {
        //     alert('mobile');
        // }
        return false
    })
}

function sub_Menu() {
    const secondLevelUL = $('.small-menu .nav-box > ul ul');
    secondLevelUL.addClass('not-opened')
    let first = true;
    let isSmallScr = screencheck(991) ? true : false;

    $(window).resize(function() {
        if(screencheck(991)){
            if(isSmallScr){
                $('.small-menu .nav-box .has-menu > ul').css('display' , 'block')
                gsap.set('.small-menu .nav-box .has-menu > ul > li > a',{
                    y: '0',
                    opacity: 1
                })
                
                $('.small-menu .nav-box .has-menu > ul').wrap('<div class="sub-menu-wrapper"></div>')
                $('.sub-menu-wrapper').wrap('<div class="sub-menu-container"></div>')
                $('.sub-menu-container').prepend('<div class="backtomenu-row"><a href="#" class="close-sub-menu">zurück</a></div>')
                gsap.set('.sub-menu-container',{
                    x: '100%',
                    opacity: 0
                })

                isSmallScr = false;
            }
        }else{
            if(!isSmallScr){
                $('.backtomenu-row').remove()
                $('.small-menu .nav-box .has-menu ul').each(function() {
                    while($(this).parents('.sub-menu-container').length) {
                        $(this).unwrap()
                    }
                })
                
                $('.small-menu .nav-box .has-menu > ul').css('display' , 'none')

                 gsap.set('.small-menu .nav-box .has-menu > ul > li > a',{
                    y: '-30px',
                    opacity: 0
                })
                 
                isSmallScr = true;
            }
        }
    })

    $('.small-menu .nav-box .has-menu > a').on('click' , function() {
        let $this = $(this)
        let siblingUlElem = $this.siblings('ul')
        let notOpenUlElem = $this.siblings('ul.not-opened')
        let openUlElem = $this.siblings('ul.open')
        let animateElem = siblingUlElem.children('li')
        let parentLiElem = $this.closest('li')
        let siblingLiElem = parentLiElem.siblings('li')

        if(!screencheck(991)){
            // for open menu
            if(notOpenUlElem.length){

                // handling sibling click to closing current open menu
                if(siblingLiElem.hasClass('open')){
                    let thisSiblingLi = siblingLiElem
                    
                    gsap.to(siblingLiElem.find('.open').find('a'),{
                        y: '-30px',
                        opacity: 0,
                        stagger: 0.025,
                        duration: animationDuration,
                        ease: animationEase,
                        onComplete: ()=>{
                            thisSiblingLi.find('ul').css('display' , 'none')
                        }
                    })
                    
                    thisSiblingLi.find('ul.open').removeClass('open').addClass('not-opened')
                    setTimeout(() => {
                        thisSiblingLi.find('li.open').removeClass('open')
                        siblingLiElem.removeClass('open')
                    },0);
                }

                notOpenUlElem.css('display', 'block').removeClass('not-opened').addClass('open')
                parentLiElem.addClass('open')
                gsap.to(animateElem.children('a'),{
                    y: '0',
                    opacity: 1,
                    stagger: 0.025,
                    duration: animationDuration,
                    ease: animationEase,
                    delay: siblingLiElem.hasClass('open') ? animationDuration  : 0 
                })

                // closing current menu and opening sibling menu if click on sibling 
                if(notOpenUlElem.find('.open').length){
                    gsap.to(notOpenUlElem.find('.open').find('a'),{
                        y: '0',
                        opacity: 1,
                        stagger: 0.025,
                        duration: animationDuration,
                        ease: animationEase,
                        onStart: () =>{
                            notOpenUlElem.find('.open').css('display', 'block')
                        }
                    })
                }
            }

            // for closemenu
            if(openUlElem.length){
                gsap.to(animateElem.find('a'),{
                    y: '-30px',
                    opacity: 0,
                    stagger: 0.025,
                    duration: animationDuration,
                    ease: animationEase,
                    onComplete: () =>{
                        openUlElem.css('display', 'none').addClass('not-opened').removeClass('open')
                        parentLiElem.removeClass('open')
                    }
                })
            }

        }else{
            $this.parents('#mainmenu .nav-main').length ? $this.parents('#mainmenu .nav-main').css('overflow' , 'hidden') : null 
            $this.parents('.sub-menu-container').length ? $this.parents('.sub-menu-container').css('overflow' , 'hidden'): null; 
            
            gsap.to($this.siblings('.sub-menu-container'),{
                x: '0',
                opacity: 1,
                clearProps: true,
                duration: animationDuration, 
                ease: animationEase
            })
        }
        return false;
    })

    // for mobile menu 
    setTimeout(() => {
        $('.close-sub-menu').on('click' , function() {
            let parent = $(this).closest('.sub-menu-container')
            $(this).closest('.has-menu').removeClass('open')
            
            $(this).parentsUntil('#menu .nav-main').each(function(index ,elem) {
                if($(elem).attr('style')){
                    let attr = $(elem).attr('style')
                    if(attr.includes('overflow: hidden') && !attr.includes('overflow: hidden auto')){
                        $(elem).css('overflow' , 'hidden auto')
                        return false;                        
                    }
                }
            })

            gsap.to(parent,{
                x: '100%',
                opacity : 0,
                duration: animationDuration,
                ease: animationEase
            })
            return false;
        })
    }, 0);
        
}   
sub_Menu();


if($(".cta-header .external-link").length){
    const externalLink = $('.cta-header .external-link, .cta-header .external-link-secondary');
    const appendToElem = $('#header #mainmenu .menu-main .header-contact');
    
    let isAppend = false;
    $(window).resize(function(){
        if(screencheck(991)){
            if(!isAppend){
                externalLink.prependTo(appendToElem);
                isAppend = true;
            }
        }else{
            if(isAppend){
                externalLink.prependTo('#header .cta-header')
                isAppend = false;
                // $("#mainmenu .menu-main ul li").attr("style","")
            }
        }
    })

}

if($('#mainmenu .nav-row .nav-filter-col .has-menu').length){
    $('#mainmenu .nav-row .nav-filter-col .has-menu').parents('.nav-filter-col').siblings('.nav-filter-col').addClass('col-small')
}

$('#mainmenu .menu-main > ul > li > a').each(function() {
    if(!$(this).siblings('.nav-main').length){
        $(this).addClass('no-inner-menu')
    }
})

// module.exports = navItem;
export default navItem;